const { VITE_AUTH_URL } = import.meta.env;
import { getOrganizationId } from "../api/organization";

export const getLoginUrl = ({ currentUrl }: { currentUrl: string }): string => {
  const authUrl = new URL(VITE_AUTH_URL);
  const currentUrlObject = new URL(currentUrl);
  const isAuthDomain = authUrl.origin === currentUrlObject.origin;

  const targetUrl = isAuthDomain ? currentUrlObject : authUrl;

  if (isAuthDomain && currentUrlObject.pathname !== "/login") {
    targetUrl.pathname = "/login";

    return targetUrl.toString();
  } else {
    const currentOrgId = getOrganizationId();
    targetUrl.searchParams.set("organization_id", currentOrgId);
    targetUrl.searchParams.set("redirect_uri", currentUrlObject.toString());
    return targetUrl.toString();
  }
};
